import { get } from ".";

export const getNotificationsApi = async (projectId) => {
  return await get(`project/${projectId}/notifications`, {});
};

export const getAdminNotificationsApi = async () => {
  return await get('notifications/admin');
};